import Vue from 'vue';
import VueI18n from 'vue-i18n';
import MQ from 'vue-match-media/dist/index';
import { store } from '@/stores';
import router from '@/router';
import '@/icons';
import '@/resources/scss/global.scss';
import KeycloakService from '@/services/KeycloakService';
import messages from '@/i18n/messages';
import Component from 'vue-class-component';
import { Config } from '@/util/Config';
import App from './App.vue';
import Vue2TouchEvents from 'vue2-touch-events';
import LocalStorageKeys from '@/util/LocalStorageKeys';
import { ShopContext } from '@/util/ShopContext';
import 'core-js/es/set';
import 'core-js/features/array/from';
import VueEvents from 'vue-events';
import VueCookie from 'vue-cookies';

console.info('Version', Config.APP_VERSION); // tslint:disable-line no-console

ShopContext.init();
Component.registerHooks(['beforeRouteUpdate']);
KeycloakService.initOnce().then();

Vue.config.productionTip = false;
Vue.use(Vue2TouchEvents);
Vue.use(VueI18n);
Vue.use(MQ);
Vue.use(VueEvents);
Vue.use(VueCookie);

const i18n = new VueI18n({
  locale: localStorage.getItem(LocalStorageKeys.SelectedLanguage) ?? Config.DEFAULT_LANGUAGE,
  fallbackLocale: Config.FALLBACK_LANGUAGE,
  messages,
});

export const app = new Vue({
  router,
  store,
  i18n,
  mq: {
    tabletOrMore: '(min-width: 768px)',
    desktop: '(min-width: 1024px)',
  },
  render: (h) => h(App),
}).$mount('#app');
